// ==================
// == FONT IMPORTS ==
// ==================

/* some import here */

// ==================
// == FONT HELPERS ==
// ==================

const fontFace = (name, src, fontWeight = 'normal', fontStyle = 'normal') => `
    @font-face{
        font-family: '${name}';
        src: local('${name}'),
             url(${require(`static/fonts/${src}.woff`)}) format('woff');
        font-style: ${fontStyle};
        font-weight: ${fontWeight};
    }
`;

// ==================
// == FONT EXPORTS ==
// ==================

export const FONTFACE_CIRCULAR = `
    ${fontFace('Circular', 'CircularStd-Book', 300)}
    ${fontFace('Circular', 'CircularStd-BookItalic', 300, 'italic')}
    ${fontFace('Circular', 'CircularStd-Bold', 700)}
    ${fontFace('Circular', 'CircularStd-BoldItalic', 700, 'italic')}
    ${fontFace('Circular', 'CircularStd-Medium', 500)}
    ${fontFace('Circular', 'CircularStd-MediumItalic', 500, 'italic')}
`;
